import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import FilterType from '../../../shared/enums/filter-type.enums';

import ViewportType from '../../../shared/enums/viewport-type.enums';
import { IconComponent } from '../../atoms/icon/icon.component';
import { FontAwesomeService } from '../../../services/fontawesome.service';

@Component({
  selector: 'hdi-filter',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, IconComponent],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class FilterComponent {
  protected readonly FilterType = FilterType;
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() isSelected = false;
  @Input() type: FilterType = FilterType.Button;
  @Input() label?: string;
  @Input() disabled?: boolean;
  @Input() icon: string = 'check';
  @Input() hasCheckmark = true;
  @Output() clickEvent = new EventEmitter<string>();

  constructor(private fontAwesomeService: FontAwesomeService) {}

  Icon = (): string => {
    switch (this.type) {
      case FilterType.Chips: {
        return 'xmark';
      }
      default: {
        return 'check';
      }
    }
  };

  selectFilter = (): void => {
    this.isSelected = !this.isSelected;
    this.clickEvent.emit(this.label);
  };
}
